import { render, staticRenderFns } from "./CoDropdownListTokens.vue?vue&type=template&id=6c3afaf6&scoped=true&"
import script from "./CoDropdownListTokens.vue?vue&type=script&lang=js&"
export * from "./CoDropdownListTokens.vue?vue&type=script&lang=js&"
import style0 from "./CoDropdownListTokens.vue?vue&type=style&index=0&id=6c3afaf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3afaf6",
  null
  
)

export default component.exports